import { englishType } from 'types'

export const lesson16: englishType[] = [
  {
    id: 1,
    word: "exhibition",
    meaning: ["전시회"]
  }, {
    id: 2,
    word: "impressionist",
    meaning: ["인상파의"]
  }, {
    id: 3,
    word: "modern",
    meaning: ["현대적인", "현대의"]
  }, {
    id: 4,
    word: "virtual",
    meaning: ["가상의"]
  }, {
    id: 5,
    word: "virtual reality",
    meaning: ["가상현실"]
  }, {
    id: 6,
    word: "choir",
    meaning: ["합창단", "성가대"]
  }, {
    id: 7,
    word: "row",
    meaning: ["열", "줄"]
  }, {
    id: 8,
    word: "background",
    meaning: ["배경"]
  }, {
    id: 9,
    word: "conduct",
    meaning: ["지휘하다", "수행하다"]
  }, {
    id: 10,
    word: "zoom in",
    meaning: ["확대하다"]
  }, {
    id: 11,
    word: "zoom out",
    meaning: ["축소하다"]
  }, {
    id: 12,
    word: "audience",
    meaning: ["청중", "관중"]
  }, {
    id: 13,
    word: "call",
    meaning: ["부르다", "전화하다", "연락하다", "호출하다"]
  }, {
    id: 14,
    word: "perform",
    meaning: ["공연하다"]
  }, {
    id: 15,
    word: "composer",
    meaning: ["작곡가"]
  }, {
    id: 16,
    word: "composition",
    meaning: ["작곡"]
  }, {
    id: 17,
    word: "post",
    meaning: ["게시하다"]
  }, {
    id: 18,
    word: "pure",
    meaning: ["순수한", "깨끗한"]
  }, {
    id: 19,
    word: "inspire",
    meaning: ["영감을 주다"]
  }, {
    id: 20,
    word: "inspiration",
    meaning: ["영감"]
  }, {
    id: 21,
    word: "choral",
    meaning: ["합창의"]
  }, {
    id: 22,
    word: "sent out a call",
    meaning: ["요청했다"]
  }, {
    id: 23,
    word: "go through",
    meaning: ["겪다", "경험하다"]
  }, {
    id: 24,
    word: "on one's own",
    meaning: ["혼자서", "스스로"]
  }, {
    id: 25,
    word: "participant",
    meaning: ["참가자"]
  }, {
    id: 26,
    word: "put together",
    meaning: ["합하다", "합치다"]
  }, {
    id: 27,
    word: "performance",
    meaning: ["공연", "수행"]
  }, {
    id: 28,
    word: "despite",
    meaning: ["~에도 불구하고"]
  }, {
    id: 29,
    word: "appreciate",
    meaning: ["감사하다"]
  }, {
    id: 30,
    word: "even",
    meaning: ["심지어"]
  }, {
    id: 31,
    word: "in person",
    meaning: ["직접"]
  }, {
    id: 32,
    word: "thousands of",
    meaning: ["수천의", "수천가지의", "수천개의"]
  }, {
    id: 33,
    word: "feature",
    meaning: ["중요한 역할을 하다", "주연하다"]
  }, {
    id: 34,
    word: "bring ~ together",
    meaning: ["결합하다", "하나로 모으다"]
  }, {
    id: 35,
    word: "release",
    meaning: ["발표하다", "출시하다", "공개하다", "석방하다", "해방하다", "놓아주다", "발간하다"]
  }, {
    id: 36,
    word: "soul",
    meaning: ["사람", "영혼", "혼", "마음", "정신"]
  }, {
    id: 37,
    word: "electronic",
    meaning: ["전자의"]
  }, {
    id: 38,
    word: "go to any length to",
    meaning: ["~하기 위해 무엇이든 하다", "모든 노력을 다하다"]
  }, {
    id: 39,
    word: "marriage",
    meaning: ["결합", "결혼"]
  }, {
    id: 40,
    word: "connectivity",
    meaning: ["연결성"]
  }, {
    id: 41,
    word: "renew",
    meaning: ["갱신하다"]
  }, {
    id: 42,
    word: "bond",
    meaning: ["유대", "유대감"]
  }, {
    id: 43,
    word: "prefer",
    meaning: ["선호하다", "좋아하다"]
  }, {
    id: 44,
    word: "be moved",
    meaning: ["감동받다", "감명을 받다", "감명받다"]
  }, {
    id: 45,
    word: "touched",
    meaning: ["감동받다", "감명을 받다", "감명받다"]
  }, {
    id: 46,
    word: "alone",
    meaning: ["혼자", "혼자서"]
  }, {
    id: 47,
    word: "along",
    meaning: ["함께"]
  }, {
    id: 48,
    word: "among",
    meaning: ["~에 둘러싸인", "~가운데", "~중에", "중에서", "~간에"]
  }, {
    id: 49,
    word: "seldom",
    meaning: ["좀처럼 않는", "좀처럼 거의 아닌", "좀처럼 거의 않는"]
  }, {
    id: 50,
    word: "circumstance",
    meaning: ["환경", "형편"]
  }, {
    id: 51,
    word: "circumstances",
    meaning: ["사정", "상황"]
  }, {
    id: 52,
    word: "conclusion",
    meaning: ["결론", "결말"]
  }, {
    id: 53,
    word: "asleep",
    meaning: ["잠이 든", "자고 있는"]
  }, {
    id: 54,
    word: "comport",
    meaning: ["행동하다"]
  }, {
    id: 55,
    word: "Which do you prefer A or B",
    meaning: ["A와 B중 무엇을 더 선호하시나요?"]
  }, {
    id: 56,
    word: "Have you heard about A",
    meaning: ["A에 대해 들어본 적 있나요?", "A에 대해 들어보셨나요?"]
  },
]
